<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height p-3">
      <div class="card-body">
        <div class="row mb-4">
          <div class="col-5" v-if="isUserStaff()">

            <div class="d-flex">
              <date-picker v-model="creditSelectedDate" range class="me-3" placeholder="Select Dates for Report"></date-picker>
              <button v-if="httpLoading" class="btn btn-dark me-1" :disabled="httpLoading">Loading</button>
              <button v-else  class="btn btn-info me-1 w-100" @click="downloadCreditNotesReport">Download Credit Notes Report</button>
            </div>
          </div>
          </div>
        <TableLoading v-if="creditNotes.page === 0"/>
        <div v-else>
          <div class="mb-4 float-end">
            <b-button v-b-modal.credit-note variant="primary">Generate Credit Note</b-button>
          </div>
          <h2 class="card-title-desc">Credit Notes</h2>
          <data-table :columns="columns" :rows="creditNotes.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
            <template v-slot:actions="slotProps">
              <div class="button-items">
                <b-button variant="info" size="sm" class="py-1 text-white" @click="viewOrderInvoice(slotProps.row.order.publicId)">
                  View Invoice
                </b-button>
                <b-button variant="dark" size="sm" class="py-1 text-white" @click="viewCreditNote(slotProps.row.publicId)">
                  View Credit Note
                </b-button>
              </div>
            </template>
          </data-table>
          <b-pagination
              v-model="currentPage"
              :total-rows="creditNotes.total"
              :per-page="perPage"
              size="lg"
              align="center"
              class="mt-3"
          />
        </div>
      </div>
    </div>
    <b-modal
        id="credit-note"
        centered
        hide-footer
        hide-header
        size="lg"
        title-class="font-18">
      <div class="p-2">
        <h3 class="mb-4">Generate Credit Note</h3>
        <credit-note-generation-component @creditAction="createCreditNote"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('credit-note')">Close</b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {mapActions, mapGetters} from "vuex";
import {errorToast, successToast} from "@/components/successToast";
import CreditNoteGenerationComponent from "@/components/finance/credit-note-generation-component";
import {ALL_CREDIT_NOTES} from "@/gql/orders";
import DataTable from "@/components/data-table";
import TableLoading from "@/components/TableLoading";
import {routeItems} from "@/router/endpoints";
import moment from "moment";
import {downloadFileConfig} from "@/filters/downloadFileConfig";

export default {
  components: {TableLoading, DataTable, CreditNoteGenerationComponent, Layout, PageHeader},
  page: {
    title: "Credit Notes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  name: "create-sample-order",
  data() {
    return {
      title: "Credit Notes",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Credit Notes",
          active: true
        }
      ],
      creditNotes: {
        page: 0,
        objects: []
      },
      searchKeyword: '',
      perPage: 30,
      currentPage: 1,
      creditSelectedDate: "",
      columns: [
        {
          field: 'noteRef',
          label: 'Note Ref'
        },
        {
          field: 'createdAt',
          label: 'Credit Note Date'
        },
        {
          field: 'order.customer.name',
          label: 'Customer Name'
        },
        {
          field: 'order.invoiceId',
          label: 'Order'
        },
        {
          field: 'remarks',
          label: 'Remarks'
        },
        {
          field: 'actions',
          label: 'Actions'
        },
      ]
    }
  },
  apollo:{
    creditNotes: {
      query: ALL_CREDIT_NOTES,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword,
        }
      }
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading',
      httpLoading: 'http/httpLoading',
      httpErrors: 'http/httpErrors'
    }),
  },
  methods: {
    ... mapActions({
      addNewCreditOrder: 'orders/addNewCreditOrder',
      generateCreditNotesReport: 'http/generateCreditNotesReport',
    }),
    async createCreditNote(data){
      await this.addNewCreditOrder(data).then(resp => {
        if(resp.publicId){
          successToast(`Credit Note created successfully`)
          this.$apollo.queries.creditNotes.refetch()
        }

      })
    },
    searchFn(data){
      this.searchKeyword = data
    },
    viewOrderInvoice(public_id){
      this.$router.push({path: routeItems.customer_order_invoice_route+'/'+public_id, query: {keyword: this.searchKeyword}}).catch(() => {})
    },
    viewCreditNote(public_id){
      this.$router.push({path: routeItems.single_credit_note_route+'/'+public_id, query: {keyword: this.searchKeyword}}).catch(() => {})
    },
    async downloadCreditNotesReport(){
      if (this.creditSelectedDate !== ''){
        const start = moment(this.creditSelectedDate[0]).format('YYYY-MM-DD')
        const end = moment(this.creditSelectedDate[1]).format('YYYY-MM-DD')
        const response = await this.generateCreditNotesReport({'start': start, 'end': end})
        if(response.headers['content-type'] === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
          downloadFileConfig(response, `Credit Notes ${start} - ${end} Report.xlsx`)
        }else {
          errorToast('Error generating credit notes report')
        }
      }else {
        errorToast('Date selection cannot be blank')
      }
    },
  }
}
</script>

<style scoped>

</style>
